// extracted by mini-css-extract-plugin
export var form = "Newsletter-module--form--Mry2J";
export var loader = "Newsletter-module--loader--kZztw";
export var rotate = "Newsletter-module--rotate--uPs58";
export var wrapper = "Newsletter-module--wrapper--8BP73";